var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"report-pc"},[_c('Pc',{ref:"pcComponent"})],1),_c('div',{staticClass:"report-h5"},[_c('H5',{ref:"h5Component"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }